// Figma DS 3.0 팔레트. 이 레포의 레거시 styles/designSystem/colors.js 가 아니라
// react styles/ColorVariables.tsx 와 같은 값 — 마이그레이션 시 var(--color-*) 로 치환한다.
export const DS = {
    'gray-white': '#FFFFFF',
    'gray-5': '#F8F9FA',
    'gray-10': '#F4F6F8',
    'gray-30': '#E2E7EB',
    'gray-40': '#D9DEE3',
    'gray-70': '#949AA1',
    'gray-80': '#6E767D',
    'gray-100': '#3C464F',
    'blue-5': '#F1F9FF',
    'blue-20': '#ADD8FF',
    'blue-50': '#2C8DFF',
    'blue-60': '#0E74F5',
    'blue-70': '#1557D9',
};
